const reducer = (state, action) => {
  if (action.type === "SET_LOADING") {
    return { ...state, isLoading: true, showAlert: false, editComplete: false };
  }

  if (action.type === "FETCH_NFTS_SUCCESS") {
    return {
      ...state,
      isLoading: false,
      nfts: action.payload,
    };
  }

  if (action.type === "FETCH_NFTS_ERROR") {
    return { ...state, isLoading: false };
  }

  if (action.type === "FETCH_SELLERS_SUCCESS") {
    return {
      ...state,
      isLoading: false,
      sellers: action.payload,
    };
  }
  if (action.type === "FETCH_SELLERS_ERROR") {
    return { ...state, isLoading: false };
  }

  if (action.type === "FETCH_SINGLE_SELLER_SUCCESS") {
    return { ...state, isLoading: false, seller: action.payload };
  }
  if (action.type === "FETCH_SINGLE_SELLER_ERROR") {
    return { ...state, isLoading: false, seller: "", singleSellerError: true };
  }

  if (action.type === "FETCH_SINGLE_NFT_SUCCESS") {
    return { ...state, isLoading: false, nft: action.payload };
  }
  if (action.type === "FETCH_SINGLE_NFT_ERROR") {
    return { ...state, isLoading: false, nft: "", singleNftError: true };
  }
};

export default reducer;
